import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPlugin from '@bugsnag/plugin-react';

Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_KEY!,
    releaseStage: process.env.REACT_APP_ENVIRONMENT!,
    enabledReleaseStages: ['staging', 'production'],
    plugins: [new BugsnagPlugin()],
});

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

export {
    Bugsnag,
    ErrorBoundary
};
